
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hook",
      function () {
        return require("private-next-pages/hook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hook"])
      });
    }
  